import React, { useEffect } from "react";
import { AppRouter } from "./routes/AppRouter";
import BaseLayout from "./components/layouts/BaseLayout";
import { create } from "zustand";
import "./App.css";
import "./pages/public/poster/components/i18n";
import { AuthService } from "./services/AuthService";
import { themeStore } from "./components/themes/BaseTheme";
import { createMenuitemHirarchy, Menuitem } from "./model/System";
import { Tree } from "./model";
import localStorageService, { LocalStorageKeys } from "./services/LocalStorageService";

export const authStore = create<{
  isLoggedin: boolean;
  initialLoad: boolean;
  initialAuthLoad: boolean;
  username: string;
  userRoles: string[];
  mainRoutes: Menuitem[];
  mainRoutesTree: Tree<Menuitem>;
  profileRoutes: Menuitem[];
}>((setState, getState) => ({
  isLoggedin: false,
  initialLoad: false,
  initialAuthLoad: false,
  username: "",
  userRoles: [],
  mainRoutes: [],
  mainRoutesTree: new Tree([]),
  profileRoutes: [],
}));

export const tenantStore = create<{
  name: string;
  displayName: string;
}>((setState, getState) => ({
  name: "",
  displayName: "",
}));

function App() {

  useEffect(() => {
    fetch("/api/getInfo", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(response => {
      if (response.ok) {
        response.json().then(res => {
          let pal = res.palette;
          themeStore.getState().updateColors(pal.primary, pal.secondary, pal.success);
          tenantStore.setState({ name: res.name, displayName: res.displayName });
        })
      }
    }).finally(() => {
      console.log("initialLoad in App");
      authStore.setState({ initialLoad: true });
    })
  }, []);

  return (
    <BaseLayout>
      <AppRouter />
    </BaseLayout>
  );
}

export default App;
